<template>
  <v-app style="min-height: 100vh; width: 100%; overflow-x: hidden">
    <!-- <NavBar v-if="$route.path != '/login' " /> -->
    <!-- <NavBar v-if="$route.path != '/login' && Snippet_Status == false " /> -->
    <NavBar
      v-if="
        $route.path != null &&
        $route.path.toLocaleLowerCase() != '/login' &&
        $route.path.toLocaleLowerCase() != '/redirectfromlogin' &&
        $route.path.toLocaleLowerCase() != '/loginsnippet' &&
        !$route.path.toLocaleLowerCase().includes('error')
      " v-model:imageLogo="LoginLogo"
      myEvent="LoginLogo"
    />

    <!-- <v-content> -->

    <v-main
      style="
        min-height: calc(100vh - 64px);
        width: 100%;
        flex: 1;
        overflow-x: hidden;
        background-color: #ffffff;
        top: 0 !important;
      "
      :style="(isFullStreamReDesignRoute ? 'padding-top: 25px !important' : isFlowCreatorRoute ? 'padding-top: 10px !important;padding-bottom: 15px !important;' : '')"
    >
      <router-view></router-view>
    </v-main>
    <!-- </v-content> -->
  </v-app>
</template>

<script>
import Cookies from "js-cookie";
import NavBar from "./components/NavBar.vue";
import Swal from "sweetalert2";
import { ref, computed, toRef, reactive } from "vue";
import { mapState, useStore } from "vuex";
export default {
  name: "App",
  provide() {
    return {
      getStartUpImage: this.GetStartUpImage,
      Click_History_List: this.Click_History_List,
      DeleteTopicStream: this.DeleteTopicStream,
      RenameClick: this.RenameClick,
      RenameTopicStream: this.RenameTopicStream,
      keyupKeyRename: this.keyupKeyRename,
      SetStatusKeyRename: this.SetStatusKeyRename,
      GetModelFirst_Value: this.GetModelFirst_Value,
      GetModelFirst: this.GetModelFirst,
      getIMG: this.getIMG,
      NotificationTokenExpired: this.NotificationTokenExpired,
      isFeedback: ref(this.isFeedback),
      User_Id_Show: ref(this.User_Id_ShowData),
      User_Id: ref(this.User_IdData),
      Time_Delay: ref(this.Time_DelayData),
      flagShowTopic: ref(this.flagShowTopicData),
      listTopic: toRef(this, "listTopicData"),
      TopicName: toRef(this, "TopicNameData"),
      ModelFirst: toRef(this, "ModelFirstData"),
      firstModel: toRef(this, "firstModel"),
      ChatbotName: toRef(this, "ChatbotNameData"),
      Loading_History_Status: toRef(this, "Loading_History_Status"),
      Log_History_TopicID: toRef(this, "Log_History_TopicIDData"),
      IsAllowImage: toRef(this, "IsAllowImage"),
      maximumChatInput: toRef(this, "maximumChatInput"),
      Username: toRef(this, "username"),
      RoleId: toRef(this, "roleId"),
      Log_History_Take: ref(this.Log_History_TakeData),
      Log_History_ID: ref(this.Log_History_IDData),
      tabSocialType: ref(this.tabSocialTypeData),
      KeyTopic: ref(this.KeyTopicData),
      Snippet_Status: ref(this.Snippet_StatusData),
      Snippet_Username: ref(this.Snippet_UsernameData),
      isAllowLLMChange: ref(this.isAllowLLMChange),
      selectedLLMModelInChat: ref(this.selectedLLMModel),
      TopicModelID: ref(this.TopicModelIDData),
      lastLLMID: ref(this.lastLLMID),

      // appState: reactive({
      //   colorThemeChat: toRef(this, "colorThemeChat")
      // }),
      colorThemeChat: computed(() => this.colorThemeChat),
      flagNav: computed(() => this.flagNav),
      LoginLogo: computed(() => this.LoginLogo),
      IconChat: computed(() => this.IconChat),
      ChatbotIcon: computed(() => this.ChatbotIcon),
      NavbarIcon: computed(() => this.NavbarIcon),
      // ChatbotName: computed(() => this.ChatbotNameData),
      FontColorTitle: computed(() => this.FontColorTitle),
      NavbarBackGround: computed(() => this.NavbarBackGround),
      SubNavbarBackGround: computed(() => this.SubNavbarBackGround),
      unreadCount: computed(() => this.unreadCountData),
      Status_Error: computed(() => this.Status_ErrorData),
      User_Id_Status: computed(() => this.User_Id_StatusData),
      LeftNavBar: computed(() => this.LeftNavBarData),
      SetPopup: ref(this.SetPopupData),
      flagGetAllTopic: computed(() => this.flagGetAllTopicData),
      miniVariant: computed(() => this.miniVariantData),
      NavbarTxtColorTheme: computed(() => this.NavbarTxtColorThemeData),
      NavbarBtnColorTheme: computed(() => this.NavbarBtnColorThemeData),
      auth_token: computed(() => this.auth_tokenData),
      TopicModelID_long: computed(() => this.TopicModelID_longData),
      StatusKeyRename: computed(() => this.StatusKeyRenameData),
      Flag_Click_History: computed(() => this.Flag_Click_HistoryData),
      isImgIconChat: computed(() => this.isImgIconChatData),
      Region: computed(() => this.Region),
      SubscriptionKey: computed(() => this.SubscriptionKey),
      IsChainMassage: computed(() => this.IsChainMassage),
      FileUploadLimit: computed(() => this.FileUploadLimit),
      
    };
  },
  setup() {
    const store = useStore();

    return { store };
  },
  components: {
    NavBar,
  },
  computed: {
    ...mapState(['Snippet_StatusData', {
      isDrawerActuallyOpen: (state) => state.isDrawerOpen,
    }]),
    isFullStreamReDesignRoute() {
      return this.$route.name === "FullStream";
    },
    isFlowCreatorRoute() {
      return this.$route.name === "FlowCreator";
    },
  },
  data() {
    return {
      isTextToImageModel: false,
      isAllowLLMChange: false,
      selectedLLMModel: null,
      FileUploadLimit: null,
      maximumChatInput: 20000,
      Region: import.meta.env.VITE_APP_Region,
      SubscriptionKey: import.meta.env.VITE_APP_SubscriptionKey,
      IsChainMassage: false,
      listTopicData: [], // [ { "topicID": 60, "topicName": "ABC", "status": false },]
      Flag_Click_Rename: false,
      Flag_Click_HistoryData: false,
      Loading_History_Status: false,

      Log_History_TakeData: 5,
      // Log_History_TopicID: null,
      Log_History_TopicIDData: -1,

      Log_History_IDData: null,

      KeyTopicData: null,
      // KeyTopic: "d332ccb2-b020-4373-a8de-8fe722651bec",

      TopicNameData: "",

      //TopicModelID : "1"

      TopicModelIDData: "",
      TopicModelID_longData: -1,
      StatusKeyRenameData: false,
      ModelFirstData: "-",
      firstModel: "-",
      isFeedback: false,
      auth_tokenData: null,

      ChatbotNameData: "Chatbot",
      ChatbotIcon: null,
      FontColorTitle: null,
      colorThemeChat: null,
      NavbarBtnColorThemeData: null,
      NavbarTxtColorThemeData: null,
      isImgIconChatData: null,

      LoginLogo: null,
      IconChat: null,
      NavbarIcon: null,
      NavbarBackGround: null,
      SubNavbarBackGround: null,
      IsAllowImage: false,
      flagNav: false,
      lastLLMID: null,
      countff: 0,
      // headerTitle: "@/assets/images/Rectangle 51.png",
      // headerCover: "@/assets/images/Rectangle 51.png",
      // headerC: "@/assets/images/Rectangle 51.png",
      parameterURL: [],
      tabSocialTypeData: [
        { text: "All", value: "All", unreadCount: 0 },
        { text: "Facebook", value: "Facebook", unreadCount: 0 },
        { text: "Line", value: "Line", unreadCount: 0 },
        { text: "Instagram", value: "Instagram", unreadCount: 0 },
      ],
      unreadCountData: 0,
      Status_ErrorData: false,
      Snippet_UsernameData: "",
      Snippet_StatusData: false,
      User_Id_ShowData: "",
      User_IdData: "",
      User_Id_Status: false,
      Time_DelayData: 65,
      flagShowTopicData: true,
      LeftNavBarData: true,
      SetPopupData: false,
      flagGetAllTopicData: false,
      miniVariantData: false,
      username : null,
      roleId: null
    };
  },
  methods: {
    SetStatusKeyRename(stat){
      var that = this;
      that.StatusKeyRename = stat;
    },
    keyupKeyRename() {
      var that = this;

      if (event.key != "Enter") {
        that.StatusKeyRenameData = true;
      }
    },
    clearInfo() {
      var that = this;
      that.listTopicData = [];
      that.TopicNameData = "";
      that.TopicModelIDData = "";
      that.TopicModelID_longData = "";
      that.ModelFirstData = "-";

      that.KeyTopicData = null;
      that.Log_History_TopicIDData = -1;
      that.Log_History_IDData = null;
      that.Flag_Click_Rename = false;
      that.Flag_Click_HistoryData = false;
      that.Loading_History_Status = false;
      that.isFeedback = false;
      that.Log_History_TakeData = 5;
    },
    Click_History_List(
      _Log_History_TopicID,
      _TopicName,
      _TopicModelID,
      _topicModelID_long,
      _keyTopic
    ) {
      var that = this;
      that.Log_History_TopicIDData = _Log_History_TopicID;
      that.Log_History_IDData = null;

      that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
      that.TopicNameData = _TopicName;

      that.TopicModelIDData = _TopicModelID;
      that.TopicModelID_longData = _topicModelID_long;

      that.ModelFirstData = _TopicModelID;
      // that.ChatbotNameData = _TopicModelID.includes('(') ? _TopicModelID.split('(')[1].split(')')[0] : _TopicModelID;
      that.KeyTopicData = _keyTopic;

      if (_Log_History_TopicID == -1) {
        if (that.listTopicData != null && that.listTopicData.length > 0) {
          if (that.listTopicData[0].topicID != -1) {
            // that.listTopic = [{ "topicID": _Log_History_TopicID, "topicName": "...", "keyTopic": "", "status": false ,"TopicModelID":"1"}].concat(that.listTopic);

            that.listTopicData = [
              {
                topicID: _Log_History_TopicID,
                topicName: _TopicName,
                keyTopic: "",
                status: false,
                topicModelID_long: _topicModelID_long,
                topicModelID: _TopicModelID,
              },
            ].concat(that.listTopicData);
          } else {
            that.listTopicData = that.listTopicData.slice(1, that.listTopicData.length);

            that.listTopicData = [
              {
                topicID: _Log_History_TopicID,
                topicName: _TopicName,
                keyTopic: "",
                status: false,
                topicModelID_long: _topicModelID_long,
                topicModelID: _TopicModelID,
              },
            ].concat(that.listTopicData);
          }
        } else {
          // that.listTopic = [{ "topicID": _Log_History_TopicID, "topicName": "...", "keyTopic": "", "status": false  ,"TopicModelID":"1"}];
          that.listTopicData = [
            {
              topicID: _Log_History_TopicID,
              topicName: _TopicName,
              keyTopic: "",
              status: false,
              topicModelID_long: _topicModelID_long,
              topicModelID: _TopicModelID,
            },
          ];
        }
      }
    },
    RenameClick(iTopic, TopicId) {
      var that = this;
      iTopic.status = true;
      that.StatusKeyRenameData = false;

      //(iTopic.TopicRef != null ? : fa)

      var _TopicId = document.getElementById(TopicId);
      if (_TopicId != undefined && _TopicId != null) {
        // _TopicId
        that.$nextTick(() => {
          _TopicId.focus();
        });
      }
    },

    GetUuidv4_Fun() {
      let Uuid = "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(
          16
        )
      );

      return Uuid;
    },
    RenameTopicStream(_TopicID, _KeyTopic, _topicName, index, tempAuth_token) {
      var that = this;
      try {
        // if (that.StatusKeyRenameData == false) {

        //   return;
        // }

        if (_KeyTopic == null || _KeyTopic == "" || _TopicID == -1) {
          _KeyTopic = that.GetUuidv4_Fun();
        }
        if (_TopicID == -1) {
          _KeyTopic = that.GetUuidv4_Fun();
        }

        that.StatusKeyRenameData = false;
        let _Data = {
          TopicID: _TopicID == null ? -1 : _TopicID,
          TopicName: _topicName,
          USER_CHANNEL: that.User_IdData,
          KeyTopic: _KeyTopic,
        };

        that.$call.RenameTopicStream(
          _Data,
          tempAuth_token,
          (response) => {
            if (response.status == 0) {
              if (_TopicID == -1) {
                that.listTopicData[index].topicID = response.data;

                that.Log_History_TopicIDData = response.data;
                that.TopicNameData = _topicName;
              }

              if (that.Log_History_TopicIDData == _TopicID) {
                that.TopicNameData = _topicName;
              }

              that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
              // that.Flag_Click_Rename = !that.Flag_Click_Rename;

              console.log("RenameTopicStream OK");
            } else {
              if (response.message == "Token has expired!!!") {
                that.NotificationTokenExpired();
              } else {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: response.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            }
          },
          () => {
            Swal.fire({
              title: "เกิดข้อผิดพลาด",
              text: "",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        );
      } catch {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          text: "",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
    DeleteTopicStream(_TopicID, _KeyTopic, _indexTopic) {
      var that = this;

      try {
        let _User_Id = {
          TopicID: _TopicID,
          KeyTopic: _KeyTopic,
          USER_CHANNEL: that.User_IdData,
        };

        if (_TopicID != -1) {
          that.$call.DeleteTopicStream(
            _User_Id,
            (response) => {
              if (response.status == 0) {
                that.listTopicData.splice(_indexTopic, 1);

                if (_User_Id.TopicID == that.Log_History_TopicIDData) {
                  if (that.listTopicData.length > 0) {
                    if (
                      that.listTopicData.length > _indexTopic - 1 &&
                      _indexTopic - 1 > 0
                    ) {
                      that.TopicNameData = that.listTopicData[_indexTopic - 1].topicName;

                      that.Log_History_TopicIDData =
                        that.listTopicData[_indexTopic - 1].topicID;
                      that.Log_History_IDData = null;
                      that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
                    } else {
                      that.TopicNameData = that.listTopicData[0].topicName;

                      that.Log_History_TopicIDData = that.listTopicData[0].topicID;

                      that.Log_History_IDData = null;
                      that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
                    }
                  } else {
                    that.TopicNameData = "";
                    (that.Log_History_TopicIDData = -1), (that.Log_History_IDData = null);
                    that.Flag_Click_HistoryData = !that.Flag_Click_HistoryData;
                  }
                }
              } else {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: response.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            },
            () => {
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "",
                showConfirmButton: false,
                timer: 1500,
              });
            }
          );
        } else {
          that.listTopicData.splice(_indexTopic, 1);
        }
      } catch {
        Swal.fire({
          title: "เกิดข้อผิดพลาด",
          text: "",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    GetModelFirst(_groupmodel, _userID) {
      var that = this;
      let domainName = null;
      let tokenParam = null;
      let ModelDisplayID = null;
      try {
        if (
          sessionStorage.getItem("Domain") != undefined &&
          sessionStorage.getItem("Domain") != null
        ) {
          domainName = sessionStorage.getItem("Domain");
        } else {
          if (that.parameterURL != null && that.parameterURL != []) {
            if (that.parameterURL.domainname != undefined) {
              domainName = that.parameterURL.domainname;
            } else if (
              sessionStorage.getItem("Domain") != undefined &&
              sessionStorage.getItem("Domain") != null
            ) {
              domainName = sessionStorage.getItem("Domain");
            }
          }
        }
        if (
          sessionStorage.getItem("tokenParam") != undefined &&
          sessionStorage.getItem("tokenParam") != null
        ) {
          tokenParam = sessionStorage.getItem("tokenParam");
        } else {
          if (that.parameterURL != null && that.parameterURL != []) {
            if (that.parameterURL.tokenParam != undefined) {
              ModelDisplayID = that.parameterURL.tokenParam;
            } else if (
              sessionStorage.getItem("tokenParam") != undefined &&
              sessionStorage.getItem("tokenParam") != null
            ) {
              ModelDisplayID = sessionStorage.getItem("tokenParam");
            }
          }
        }
        if (
          sessionStorage.getItem("modelID") != undefined &&
          sessionStorage.getItem("modelID") != null
        ) {
          ModelDisplayID = sessionStorage.getItem("modelID");
        } else {
          if (that.parameterURL != null && that.parameterURL != []) {
            if (that.parameterURL.modelid != undefined) {
              ModelDisplayID = that.parameterURL.modelid;
            } else if (
              sessionStorage.getItem("modelID") != undefined &&
              sessionStorage.getItem("modelID") != null
            ) {
              ModelDisplayID = sessionStorage.getItem("modelID");
            }
          }
        }
        let _Data = {
          groupModel: _groupmodel,
          UserSend: _userID ?? that.User_IdData,
          DomainName: domainName,
          TokenParam: tokenParam,
          ModelDisplayID: ModelDisplayID,
        };
        if (that.Log_History_TopicIDData != -1) {
          return;
        }
        that.$call.GetModelFirst(
          _Data,
          (response) => {
            if (response.status == 0) {
              that.ModelFirstData = that.ModelFirstData == "-" ? response.data.modelDisplayID + " (" + response.data.modelName + ")" : that.ModelFirstData;
              this.firstModel = response.data.modelDisplayID + " (" + response.data.modelName + ")";
              that.TopicModelIDData = that.ModelFirstData;
              that.isAllowLLMChange = response.data.isAllowLLMChange;
              that.Time_DelayData = response.data.timeDelay;
              that.maximumChatInput = response.data.maximumChatInput;
            } else {
              that.ModelFirstData = "-";
              this.firstModel = "-";
              that.TopicModelIDData = that.ModelFirstData;
            }
          },
          () => {
            that.ModelFirstData = "-";
            this.firstModel = "-";
            that.TopicModelIDData = that.ModelFirstData;
          }
        );
      } catch (e) {
        that.ModelFirstData = "-";
        this.firstModel = "-";
        that.TopicModelIDData = that.ModelFirstData;
      }
    },
    GetModelFirst_Value(_groupmodel, _userID) {
      var that = this;
      try {
        let _Data = {
          groupModel: _groupmodel,
          UserSend: _userID ?? that.User_IdData,
        };
        if (that.Log_History_TopicIDData != -1) {
          return;
        }
        that.$call.GetModelFirst(
          _Data,
          (response) => {
            if (response.status == 0) {
              that.ModelFirstData = that.ModelFirstData == "-" ? response.data.modelDisplayID + " (" + response.data.modelName + ")" : that.ModelFirstData;
              this.firstModel = response.data.modelDisplayID + " (" + response.data.modelName + ")";
              that.isAllowLLMChange = response.data.isAllowLLMChange;
              that.Time_DelayData = response.data.timeDelay;
              that.maximumChatInput = response.data.maximumChatInput;
            } else {
              that.ModelFirstData = "-";
              this.firstModel = "-";
            }
          },
          () => {
            that.ModelFirstData = "-";
              this.firstModel = "-";
          }
        );
      } catch (e) {
        that.ModelFirstData = "-";
        this.firstModel = "-";
      }
    },
    configColor() {
      let self = this;
      self.$call.GetConfigThem(async (response) => {
        let data = response.data;

        if (response.status == 0 && response.message != "Posted invalid data.") {
          self.ChatbotNameData = data.nameChat;
          self.ChatbotIcon = data.iconChat;

          self.FontColorTitle = data.fontColorTitle;
          this.colorThemeChat = data.colorThemeChat;
          self.NavbarBtnColorThemeData = data.navbarButton;
          self.NavbarTxtColorThemeData = data.navbarColorText;
          self.isImgIconChatData = data.isImgIconChat;
        }
      });
    },
    async GetStartUpImage() {
      let self = this;
      await self.configColor();
      if (
        !self.$route.path.toLocaleLowerCase().match("snippet") &&
        !self.$route.path.toLocaleLowerCase().match("fullstream")
      ) {
        const imagePromises = [
          self.getIMG("LoginLogo.png"),
          self.getIMG("ChatIcon.png"),
          self.getIMG("NavLogo.png"),
          self.getIMG("NavBG.png"),
          self.getIMG("SubBG.png"),
        ];

        const [
          LoginLogo,
          IconChat,
          NavbarIcon,
          NavbarBackGround,
          SubNavbarBackGround,
        ] = await Promise.all(imagePromises);

        if (
          LoginLogo ||
          IconChat ||
          NavbarIcon ||
          NavbarBackGround ||
          SubNavbarBackGround
        ) {
          self.LoginLogo = LoginLogo || self.LoginLogo;
          self.IconChat = IconChat || self.IconChat;
          self.NavbarIcon = NavbarIcon || self.NavbarIcon;
          self.NavbarBackGround = NavbarBackGround || self.NavbarBackGround;
          self.SubNavbarBackGround = SubNavbarBackGround || self.SubNavbarBackGround;
          // console.log("NavbarBackGround", self.NavbarBackGround);
          // console.log("SubNavbarBackGround", self.SubNavbarBackGround);

          await self.PlaceImage();
          self.flagNav = true;
        }
      } else if (
        self.$route.path.toLocaleLowerCase().match("fullstream") ||
        self.$route.path.toLocaleLowerCase().match("snippet")
      ) {
        let NavbarBackGround = await self.getIMG("NavBG.png");
        let IconChat = await self.getIMG("ChatIcon.png");
        let NavbarIcon = await self.getIMG("NavLogo.png");
        await Promise.all([IconChat, NavbarIcon,NavbarBackGround]).then(async (val) => {
          if (val[0] != null) {
            self.IconChat = val[0];
          }
          if (val[1] != null) {
            self.NavbarIcon = val[1];
          }
          if (val[0] != null || val[1] != null) {
            await self.PlaceImage();
            self.flagNav = true;
          }
          if (val[2] != null) {
            self.NavbarBackGround = val[2];

            // SET config background navbar fullStream set ตรงนี้เพราะแยก class fullstream-header-cover ออกมา
            let headerCoverElement = document.querySelector(".fullstream-header-cover");
            if (headerCoverElement != null) {
              headerCoverElement.style.setProperty(
                "background",
                `url('${self.NavbarBackGround}')`,
                "important"
              );
              headerCoverElement.style.setProperty(
                "background-position",
                "center",
                "important"
              );
              headerCoverElement.style.setProperty("background-size", "cover", "important");
              headerCoverElement.style.setProperty(
                "background-repeat",
                "no-repeat",
                "important"
              );
            }
          }
        });
      }
    },
    PlaceImage() {
      let self = this;
      if (self.FontColorTitle != null) {
        let header_title = document.querySelectorAll(".header-title .title");
        if (header_title != null) {
          header_title.forEach((title) => {
            title.style.color = `#${self.FontColorTitle}`;
          });
        }
      }
      if (self.NavbarIcon != null) {
        let Fusion_Logo = document.querySelector(
          "#Fusion_Logo_FullStream .v-image__image"
        );
        if (Fusion_Logo != null) {
          Fusion_Logo.style.backgroundImage = `url('${self.NavbarIcon}') `;
        }
      }
      if (self.NavbarBackGround != null) {
        let headerCoverElement = document.querySelector(".header-cover");
        if (headerCoverElement != null) {
          headerCoverElement.style.setProperty(
            "background",
            `url('${self.NavbarBackGround}')`,
            "important"
          );
          headerCoverElement.style.setProperty(
            "background-position",
            "center",
            "important"
          );
          headerCoverElement.style.setProperty("background-size", "cover", "important");
          headerCoverElement.style.setProperty(
            "background-repeat",
            "no-repeat",
            "important"
          );
        }
      }
      if (self.SubNavbarBackGround != null) {
        let headerTitleElement = document.querySelector(".header-title");
        if (headerTitleElement != null) {
          headerTitleElement.style.background = `url('${self.SubNavbarBackGround}') `;
        }
      }
    },
    async getIMG(filename) {
      return await new Promise((resolve) => {
        this.$call.GetImage(
          filename,
          async (response) => {
            this.countff++;
            if (
              !this.$route.path.toLocaleLowerCase().match("snippet") &&
              !this.$route.path.toLocaleLowerCase().match("fullstream")
            ) {
              this.flagNav = this.countff >= 5;
            } else if (this.$route.path.toLocaleLowerCase().match("fullstream")) {
              this.flagNav = this.countff >= 2;
            }
            if (response.data.size === 0) {
              resolve(null);
            } else {
              const url = await window.URL.createObjectURL(new Blob([response.data]));
              resolve(url);
            }
          },
          () => {
            resolve(null);
          }
        );
      });
    },
    NotificationTokenExpired() {
      let self = this;
      self.$swal.fire({
        icon: "error",
        title: "Token has expired!!!",
        showConfirmButton: false,
      });
    },
  },
  updated() {
    let self = this;
    // if(!(self.$route.path != null && self.$route.path.toLocaleLowerCase() != '/configtheme')){
    self.PlaceImage();
    // }
  },
  async mounted() {
    let that = this;
    this.username = Cookies.get("username");
    this.roleId = Cookies.get("roleId");
    for (let key in that.$route.query) {
      that.parameterURL[key.toLowerCase()] = that.$route.query[key];
    }
    if (!(that.$route.path != null && that.$route.path.toLocaleLowerCase() != "/login")) {
      that.GetStartUpImage();
    }
    // รอจนกว่า that.$router.currentRoute.value.name จะไม่เป็น undefined
    const waitForRouteName = async () => {
      while (typeof that.$router.currentRoute.value.name === "undefined") {
        await new Promise(resolve => setTimeout(resolve, 50));
      }
    };
    await waitForRouteName();
    if (that.$router.currentRoute.value.name === "FullStream") {
      if (
        that.$route.query.snippet == null ||
        that.$route.query.snippet == undefined ||
        that.$route.query.snippet == "" ||
        that.$route.query.snippet == false
      ) {
        this.store.commit('setSnippetStatus', false);
        that.Snippet_StatusData = false;
      } else {
        this.store.commit('setSnippetStatus', true);
        that.Snippet_StatusData = true;
      }
    } else if (that.$router.currentRoute.value.name === "Snippet") {
      if (that.$route.query.flagnavbar == "true") {
        this.store.commit('setSnippetStatus', false);
        that.Snippet_StatusData = false;
      } else {
        this.store.commit('setSnippetStatus', true);
        that.Snippet_StatusData = true;
      }
    } else {
      // that.FF  = "s3"
    }
    
  },
};
</script>
<style>
/* Global font settings for the entire application */
.v-application {
  font-family: 'Poppins', 'Noto Sans Thai', sans-serif !important;
}

.v-application *,
.v-application .v-btn,
.v-application .v-list-item,
.v-application .v-card,
.v-application .v-dialog,
.v-application .v-toolbar,
.v-application .v-navigation-drawer {
  font-family: inherit !important;
}

/* Thai text specific styling */
.v-application *[lang="th"],
.v-application .thai-text {
  font-family: 'Noto Sans Thai', 'Poppins', sans-serif !important;
}

/* English text specific styling */
.v-application *[lang="en"],
.v-application .english-text {
  font-family: 'Poppins', 'Noto Sans Thai', sans-serif !important;
}

.v-content__wrap {
  background-color: #f0f0f7;
  min-height: calc(100vh - 64px);
  width: 100%;
}

.v-select.v-select--chips .v-select__selections {
  min-height: 42px !important;
}

/* เพิ่ม CSS เพื่อให้แน่ใจว่า Vuetify components มีขนาดเต็มจอ */
.v-application {
  min-height: 100vh !important;
  width: 100% !important;
}

.v-application__wrap {
  min-height: 100vh !important;
}
</style>
